var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowCarousel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  focusable: "false",
  x: "0px",
  y: "0px",
  viewBox: "0 0 20 20",
  style: {
    enableBackground: "new 0 0 20 20"
  },
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6.7,0L4.3,2.3l7.6,7.6l-7.6,7.7L6.7,20l10-10L6.7,0z"
})));
export default SvgArrowCarousel;